export const messages = {
  en: {
    ownerDetail: {
      ownerInfo: 'Owner Information',
      ownerId: 'Owner ID',
      name: 'Name',
      gender: 'Gender',
      personType: 'Person Type',
      personRole: 'Person Role',
      idCard: 'ID Card',
      contact: 'Contact',
      backupPhone: 'Backup Phone',
      contactPerson: 'Contact Person',
      creator: 'Creator',
      remark: 'Remark',
      room: 'Room',
      car: 'Car',
      member: 'Member',
      history: 'History',
      roomFee: 'Room Fee',
      paymentHistory: 'Payment History',
      account: 'Account',
      coupon: 'Coupon',
      ownerBinding: 'Owner Binding',
      complaint: 'Complaint',
      repair: 'Repair',
      visitor: 'Visitor',
      contract: 'Contract',
      receipt: 'Receipt',
      depositReceipt: 'Deposit Receipt',
      faceSync: 'Face Sync',
      accessRecord: 'Access Record',
      chargeOrder: 'Charge Order'
    },
    ownerDetailMember: {
      placeholder: {
        name: 'Please enter member name'
      },
      face: 'Face',
      name: 'Name',
      gender: 'Gender',
      role: 'Role',
      idCard: 'ID Card',
      contact: 'Contact',
      address: 'Address'
    },
    ownerDetailAccount: {
      acctId: 'Account ID',
      acctName: 'Account Name',
      phone: 'Phone',
      acctType: 'Account Type',
      amount: 'Amount',
      createTime: 'Create Time',
      prestore: 'Prestore',
      detail: 'Account Detail'
    },
 
    ownerDetailRepair: {
      repairId: 'Work Order ID',
      location: 'Location',
      repairType: 'Repair Type',
      reporter: 'Reporter',
      contact: 'Contact',
      appointmentTime: 'Appointment Time',
      status: 'Status',
      taskProcess: 'Task Process'
    },
    ownerDetailContract: {
      contractName: 'Contract Name',
      contractCode: 'Contract Code',
      parentContractCode: 'Parent Contract Code',
      contractType: 'Contract Type',
      operator: 'Operator',
      amount: 'Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      createTime: 'Create Time',
      status: 'Status'
    },
    ownerDetailHisFee: {
      feeItem: 'Fee Item',
      chargeObject: 'Charge Object',
      cycle: 'Cycle (months)',
      receivableAmount: 'Receivable/Received (yuan)',
      paymentMethod: 'Payment Method',
      paymentPeriod: 'Payment Period',
      paymentTime: 'Payment Time',
      cashier: 'Cashier',
      status: 'Status',
      remark: 'Remark',
      operation: 'Operation',
      detail: 'Detail',
      accountDeduction: 'Account Deduction'
    },
    ownerDetailReceipt: {
      print: 'Print',
      printSmall: 'Print Small',
      printApply: 'Print Application',
      feeType: 'Fee Type',
      owner: 'Owner',
      feeItem: 'Fee Item',
      chargePeriod: 'Charge Period',
      totalAmount: 'Total Amount',
      paymentTime: 'Payment Time',
      receiptId: 'Receipt ID',
      selectPrint: 'Please select receipts to print'
    },
    ownerDetailAccountReceipt: {
      print: 'Print',
      printSmall: 'Print Small',
      accountName: 'Account Name',
      accountType: 'Account Type',
      owner: 'Owner',
      prestoreAmount: 'Prestore Amount',
      prestoreMethod: 'Prestore Method',
      totalAmount: 'Total Amount',
      prestoreTime: 'Prestore Time',
      receiptId: 'Receipt ID',
      selectPrint: 'Please select receipts to print'
    },
    ownerDetailAccessControl: {
      objectType: 'Object Type',
      objectName: 'Object Name',
      command: 'Command',
      status: 'Status',
      description: 'Description',
      syncTime: 'Sync Time',
      operation: 'Operation',
      resync: 'Resync'
    },
    ownerDetailAccessControlRecord: {
      face: 'Face',
      id: 'ID',
      deviceName: 'Device Name',
      deviceCode: 'Device Code',
      userName: 'User Name',
      openType: 'Open Type',
      phone: 'Phone',
      idCard: 'ID Card',
      similarity: 'Similarity',
      openStatus: 'Open Status',
      openTime: 'Open Time',
      other: 'Other',
      success: 'Success',
      failed: 'Failed'
    },
    ownerDetailChargeMachineOrder: {
      id: 'ID',
      name: 'Name',
      phone: 'Phone',
      charger: 'Charger',
      slot: 'Slot',
      chargeHours: 'Charge Hours',
      byAmount: 'By Amount',
      hours: 'hours',
      chargeAmount: 'Charge Amount',
      startTime: 'Start Time',
      endTime: 'End Time',
      deductionAccount: 'Deduction Account',
      hourPrice: 'Hour Price',
      deductionAmount: 'Deduction Amount',
      detail: 'Detail',
      socketStatus: 'Socket Status',
      stopCharge: 'Stop Charge',
      description: 'Description'
    },
    ownerDetailRoom: {
      pleaseEnterRoomNumber: 'Please enter room number',
      roomNumber: 'Room Number',
      floor: 'Floor',
      type: 'Type',
      area: 'Area',
      rent: 'Rent',
      validity: 'Validity',
      roomStatus: 'Room Status',
      roomArrears: 'Room Arrears',
      updateDaily: 'Update daily',
      checkOut: 'Check Out',
      businessAcceptance: 'Business Acceptance',
      arrearsSubtotal: 'Arrears Subtotal',
      roomNumberPlaceholder: 'Please enter room number like 1-1-1',
      deliverRoom: 'Deliver Room'
    },
    ownerDetailCar: {
      pleaseEnterCarNumber: 'Please enter license plate number',
      addCar: 'Add Vehicle',
      carNumber: 'License Plate',
      licenseType: 'License Type',
      temporaryCar: 'Temporary Vehicle',
      carType: 'Vehicle Type',
      color: 'Color',
      owner: 'Owner',
      parkingSpace: 'Parking Space',
      parkingSpaceReleased: 'Parking Space Released',
      validityPeriod: 'Validity Period'
    },
    ownerDetailHis: {
      action: 'Action',
      operator: 'Operator',
      operateTime: 'Operate Time',
      name: 'Name',
      gender: 'Gender',
      male: 'Male',
      female: 'Female',
      idCard: 'ID Card',
      address: 'Address',
      add: 'Add',
      delete: 'Delete',
      modifyNew: 'Modify(New)',
      modifyOld: 'Modify(Old)'
    },
    ownerDetailCoupon: {
      id: 'ID',
      couponName: 'Coupon Name',
      value: 'Value',
      validity: 'Validity',
      userName: 'User Name',
      phone: 'Phone',
      purpose: 'Purpose',
      quantity: 'Quantity',
      unit: 'pcs',
      status: 'Status',
      unused: 'Unused',
      used: 'Used',
      effectiveTime: 'Effective Time'
    },
    addOwnerMember: {
      title: 'Add Member',
      personRole: 'Person Role',
      name: 'Name',
      link: 'Phone',
      sex: 'Gender',
      concactLink: 'Alternate Phone',
      address: 'Address',
      idCard: 'ID Card',
      remark: 'Remark',
      photo: 'Photo',
      uploadPhoto: 'Upload Photo',
      placeholder: {
        personRole: 'Required, please select person role',
        name: 'Required, please enter name',
        link: 'Required, please enter phone number',
        sex: 'Required, please select gender',
        concactLink: 'Optional, please enter alternate phone',
        address: 'Optional, please enter address',
        idCard: 'Optional, please enter ID card',
        remark: 'Optional, please enter remark'
      },
      role: {
        tenant: 'Tenant',
        family: 'Family Member',
        staff: 'Company Staff',
        other: 'Other'
      },
      validate: {
        nameLength: 'Name length must be between 2 and 64 characters',
        phoneFormat: 'Invalid phone number format',
        idCardFormat: 'Invalid ID card format',
        remarkLength: 'Remark length cannot exceed 200 characters',
        photoSize: 'Photo size cannot exceed 2MB'
      },
      uploadFailed: 'Photo upload failed'
    },
    editOwnerMember: {
      title: 'Edit Member',
      personRole: 'Person Role',
      name: 'Name',
      link: 'Phone',
      sex: 'Gender',
      concactLink: 'Alternate Phone',
      address: 'Address',
      idCard: 'ID Card',
      remark: 'Remark',
      photo: 'Photo',
      uploadPhoto: 'Upload Photo',
      placeholder: {
        personRole: 'Required, please select person role',
        name: 'Required, please enter name',
        link: 'Required, please enter phone number',
        sex: 'Required, please select gender',
        concactLink: 'Optional, please enter alternate phone',
        address: 'Optional, please enter address',
        idCard: 'Optional, please enter ID card',
        remark: 'Optional, please enter remark'
      },
      role: {
        tenant: 'Tenant',
        family: 'Family Member',
        staff: 'Company Staff',
        other: 'Other'
      },
      validate: {
        nameLength: 'Name length must be between 2 and 64 characters',
        phoneFormat: 'Invalid phone number format',
        idCardFormat: 'Invalid ID card format',
        remarkLength: 'Remark length cannot exceed 200 characters',
        photoSize: 'Photo size cannot exceed 2MB'
      },
      uploadFailed: 'Photo upload failed'
    }
  },
  zh: {
    ownerDetail: {
      ownerInfo: '业主信息',
      ownerId: '业主ID',
      name: '名称',
      gender: '性别',
      personType: '人员类型',
      personRole: '人员角色',
      idCard: '证件号',
      contact: '联系方式',
      backupPhone: '备用手机',
      contactPerson: '联系人',
      creator: '创建员工',
      remark: '备注',
      room: '房屋',
      car: '车辆',
      member: '成员',
      history: '修改记录',
      roomFee: '房屋费用',
      paymentHistory: '缴费历史',
      account: '账户',
      coupon: '优惠券',
      ownerBinding: '业主绑定',
      complaint: '投诉',
      repair: '报修',
      visitor: '访客',
      contract: '合同',
      receipt: '补打收据',
      depositReceipt: '预存收据',
      faceSync: '人脸同步',
      accessRecord: '开门记录',
      chargeOrder: '充电订单'
    },
    ownerDetailMember: {
      placeholder: {
        name: '请填写成员名称'
      },
      face: '人脸',
      name: '名称',
      gender: '性别',
      role: '人员角色',
      idCard: '身份证',
      contact: '联系方式',
      address: '地址'
    },
    ownerDetailAccount: {
      acctId: '账户编号',
      acctName: '账户名称',
      phone: '手机号',
      acctType: '账户类型',
      amount: '账户金额',
      createTime: '创建时间',
      prestore: '预存',
      detail: '账户明细'
    },

    ownerDetailRepair: {
      repairId: '工单编码',
      location: '位置',
      repairType: '报修类型',
      reporter: '报修人',
      contact: '联系方式',
      appointmentTime: '预约时间',
      status: '状态',
      taskProcess: '定时任务处理'
    },
    ownerDetailContract: {
      contractName: '合同名称',
      contractCode: '合同编号',
      parentContractCode: '父合同编号',
      contractType: '合同类型',
      operator: '经办人',
      amount: '合同金额',
      startTime: '开始时间',
      endTime: '结束时间',
      createTime: '起草时间',
      status: '状态'
    },
    ownerDetailHisFee: {
      feeItem: '费用项',
      chargeObject: '收费对象',
      cycle: '周期(单位:月)',
      receivableAmount: '应收/实收(单位:元)',
      paymentMethod: '缴费方式',
      paymentPeriod: '缴费起始段',
      paymentTime: '缴费时间',
      cashier: '收银员',
      status: '状态',
      remark: '备注',
      operation: '操作',
      detail: '详情',
      accountDeduction: '账户扣款'
    },
    ownerDetailReceipt: {
      print: '打印',
      printSmall: '打印小票',
      printApply: '申请单',
      feeType: '费用类型',
      owner: '业主',
      feeItem: '费用项目',
      chargePeriod: '收费时间段',
      totalAmount: '总金额',
      paymentTime: '缴费时间',
      receiptId: '收据ID',
      selectPrint: '请选择打印收据'
    },
    ownerDetailAccountReceipt: {
      print: '打印',
      printSmall: '打印小票',
      accountName: '账户名称',
      accountType: '账户类型',
      owner: '业主',
      prestoreAmount: '预存金额',
      prestoreMethod: '预存方式',
      totalAmount: '总金额',
      prestoreTime: '预存时间',
      receiptId: '收据ID',
      selectPrint: '请选择打印收据'
    },
    ownerDetailAccessControl: {
      objectType: '对象类型',
      objectName: '对象名称',
      command: '指令',
      status: '状态',
      description: '说明',
      syncTime: '同步时间',
      operation: '操作',
      resync: '重新同步'
    },
    ownerDetailAccessControlRecord: {
      face: '人脸',
      id: '编号',
      deviceName: '设备名称',
      deviceCode: '设备编码',
      userName: '用户名称',
      openType: '开门方式',
      phone: '手机号',
      idCard: '用户身份证',
      similarity: '相似度',
      openStatus: '开门状态',
      openTime: '开门时间',
      other: '其他',
      success: '开门成功',
      failed: '开门失败'
    },
    ownerDetailChargeMachineOrder: {
      id: '编号',
      name: '名称',
      phone: '手机号',
      charger: '充电桩',
      slot: '插槽',
      chargeHours: '充电小时',
      byAmount: '按量充电',
      hours: '小时',
      chargeAmount: '充电量',
      startTime: '开始时间',
      endTime: '结束时间',
      deductionAccount: '扣款账户',
      hourPrice: '小时电价',
      deductionAmount: '扣款金额',
      detail: '明细',
      socketStatus: '插座状态',
      stopCharge: '停止充电',
      description: '说明'
    },
    ownerDetailRoom: {
      pleaseEnterRoomNumber: '请填写房屋编号',
      roomNumber: '房屋编号',
      floor: '楼层',
      type: '类型',
      area: '建筑/室内面积',
      rent: '租金',
      validity: '有效期',
      roomStatus: '房屋状态',
      roomArrears: '房屋欠费',
      updateDaily: '按天更新',
      checkOut: '退房',
      businessAcceptance: '业务受理',
      arrearsSubtotal: '欠费小计',
      roomNumberPlaceholder: '请输入房屋编号 楼栋-单元-房屋 如1-1-1',
      deliverRoom: '交房'
    },
    ownerDetailCar: {
      pleaseEnterCarNumber: '请填写车牌号',
      addCar: '添加车辆',
      carNumber: '车牌号',
      licenseType: '车牌类型',
      temporaryCar: '临时车',
      carType: '车辆类型',
      color: '颜色',
      owner: '业主',
      parkingSpace: '车位',
      parkingSpaceReleased: '车位已释放',
      validityPeriod: '有效期'
    },
    ownerDetailHis: {
      action: '动作',
      operator: '操作人',
      operateTime: '操作时间',
      name: '姓名',
      gender: '性别',
      male: '男',
      female: '女',
      idCard: '身份证',
      address: '家庭住址',
      add: '添加',
      delete: '删除',
      modifyNew: '修改(新)',
      modifyOld: '修改(旧)'
    },
    ownerDetailCoupon: {
      id: '编号',
      couponName: '优惠券名称',
      value: '面值',
      validity: '有效期',
      userName: '用户名称',
      phone: '手机号',
      purpose: '用途',
      quantity: '数量',
      unit: '张',
      status: '状态',
      unused: '未使用',
      used: '已使用',
      effectiveTime: '生效时间'
    },
    addOwnerMember: {
      title: '添加成员',
      personRole: '人员角色',
      name: '住户名称',
      link: '联系手机',
      sex: '性别',
      concactLink: '备用手机',
      address: '地址',
      idCard: '身份证',
      remark: '备注',
      photo: '照片',
      uploadPhoto: '上传照片',
      placeholder: {
        personRole: '必填，请选择人员角色',
        name: '必填，请填写住户名称',
        link: '必填，请填写联系方式',
        sex: '必填，请选择性别',
        concactLink: '可选，请填写备用手机',
        address: '可填，请填写地址',
        idCard: '可选，请填写身份证',
        remark: '可填，请填写备注'
      },
      role: {
        tenant: '租客',
        family: '家庭成员',
        staff: '公司员工',
        other: '其他'
      },
      validate: {
        nameLength: '姓名长度必须在2位至64位',
        phoneFormat: '手机号格式错误',
        idCardFormat: '身份证格式不对',
        remarkLength: '备注长度不能超过200位',
        photoSize: '图片大小不能超过2MB'
      },
      uploadFailed: '照片上传失败'
    },
    editOwnerMember: {
      title: '修改成员',
      personRole: '人员角色',
      name: '住户名称',
      link: '联系手机',
      sex: '性别',
      concactLink: '备用手机',
      address: '地址',
      idCard: '身份证',
      remark: '备注',
      photo: '照片',
      uploadPhoto: '上传照片',
      placeholder: {
        personRole: '必填，请选择人员角色',
        name: '必填，请填写住户名称',
        link: '必填，请填写联系方式',
        sex: '必填，请选择性别',
        concactLink: '可选，请填写备用手机',
        address: '可填，请填写地址',
        idCard: '可选，请填写身份证',
        remark: '可填，请填写备注'
      },
      role: {
        tenant: '租客',
        family: '家庭成员',
        staff: '公司员工',
        other: '其他'
      },
      validate: {
        nameLength: '姓名长度必须在2位至64位',
        phoneFormat: '手机号格式错误',
        idCardFormat: '身份证格式不对',
        remarkLength: '备注长度不能超过200位',
        photoSize: '图片大小不能超过2MB'
      },
      uploadFailed: '照片上传失败'
    }
  }
}